import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";

const SUPPORTED = ["ar", "en"];

function LangGuard({ children }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && SUPPORTED.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
    }
  }, [lang, i18n]);

  if (!lang || !SUPPORTED.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/ar" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route
            path="/:lang"
            element={
              <LangGuard>
                <Layout />
              </LangGuard>
            }
          >
            <Route index element={<Home />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="cookies" element={<Cookies />} />
            <Route path="terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
